<textarea id="kommentarTextArea" class="form-control" [(ngModel)]="kommentar" (ngModelChange)="onChange($event)"></textarea>
